/* Tecnolatina — filtros da página mestre "Todos os produtos". Client-side, sem libs.
   Filtra por data-atributos, esconde grupos vazios, guarda estado na URL, drawer
   mobile. Ordenação é nativa Shopify (?sort_by=, recarrega). */
(function () {
  var root = document.querySelector('[data-alv-all-products]');
  if (!root) return;

  var cards = Array.prototype.slice.call(root.querySelectorAll('.alv-card'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('.alv-group'));
  var catBtns = Array.prototype.slice.call(root.querySelectorAll('.alv-cat'));
  var facetBoxes = Array.prototype.slice.call(root.querySelectorAll('input[data-facet]'));
  var pmin = root.querySelector('#alv-pmin');
  var pmax = root.querySelector('#alv-pmax');
  var countEl = root.querySelector('#alv-count');
  var applyCountEls = root.querySelectorAll('[data-alv-apply-count]');
  var emptyEl = root.querySelector('[data-alv-empty]');

  var state = { cat: 'all', diameter: new Set(), application: new Set(), installation: new Set(), pmin: null, pmax: null };

  function tokens(el, attr) { var v = (el.getAttribute(attr) || '').trim(); return v ? v.split(/\s+/) : []; }
  function anyIn(set, list) { for (var i = 0; i < list.length; i++) { if (set.has(list[i])) return true; } return false; }

  function matches(card) {
    if (state.cat !== 'all' && card.dataset.family !== state.cat) return false;
    if (state.diameter.size && !state.diameter.has(card.dataset.diameter)) return false;
    if (state.application.size && !anyIn(state.application, tokens(card, 'data-application'))) return false;
    if (state.installation.size && !anyIn(state.installation, tokens(card, 'data-installation'))) return false;
    var price = parseInt(card.dataset.price, 10) || 0; // centavos
    if (state.pmin != null && price < state.pmin * 100) return false;
    if (state.pmax != null && price > state.pmax * 100) return false;
    return true;
  }

  function apply() {
    var visible = 0;
    cards.forEach(function (c) { var ok = matches(c); c.hidden = !ok; if (ok) visible++; });
    groups.forEach(function (g) { g.hidden = g.querySelectorAll('.alv-card:not([hidden])').length === 0; });
    if (countEl) countEl.textContent = visible;
    applyCountEls.forEach(function (e) { e.textContent = visible; });
    if (emptyEl) emptyEl.hidden = visible !== 0;
    writeURL();
  }

  /* ---- URL <-> estado ---- */
  function writeURL() {
    var p = new URLSearchParams(window.location.search);
    ['cat', 'diam', 'app', 'inst', 'pmin', 'pmax'].forEach(function (k) { p.delete(k); });
    if (state.cat !== 'all') p.set('cat', state.cat);
    if (state.diameter.size) p.set('diam', Array.from(state.diameter).join(','));
    if (state.application.size) p.set('app', Array.from(state.application).join(','));
    if (state.installation.size) p.set('inst', Array.from(state.installation).join(','));
    if (state.pmin != null) p.set('pmin', state.pmin);
    if (state.pmax != null) p.set('pmax', state.pmax);
    var qs = p.toString();
    history.replaceState(null, '', window.location.pathname + (qs ? '?' + qs : ''));
  }
  function readURL() {
    var p = new URLSearchParams(window.location.search);
    state.cat = p.get('cat') || 'all';
    (p.get('diam') || '').split(',').filter(Boolean).forEach(function (v) { state.diameter.add(v); });
    (p.get('app') || '').split(',').filter(Boolean).forEach(function (v) { state.application.add(v); });
    (p.get('inst') || '').split(',').filter(Boolean).forEach(function (v) { state.installation.add(v); });
    if (p.get('pmin')) state.pmin = parseInt(p.get('pmin'), 10);
    if (p.get('pmax')) state.pmax = parseInt(p.get('pmax'), 10);
    // reflete na UI
    catBtns.forEach(function (b) { var on = b.dataset.cat === state.cat; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    facetBoxes.forEach(function (b) { b.checked = state[b.dataset.facet] && state[b.dataset.facet].has(b.value); });
    if (state.pmin != null && pmin) pmin.value = state.pmin;
    if (state.pmax != null && pmax) pmax.value = state.pmax;
  }

  /* ---- eventos ---- */
  catBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      state.cat = b.dataset.cat;
      catBtns.forEach(function (o) { var on = o === b; o.classList.toggle('is-active', on); o.setAttribute('aria-pressed', on); });
      apply();
    });
  });
  facetBoxes.forEach(function (b) {
    b.addEventListener('change', function () {
      var set = state[b.dataset.facet];
      if (b.checked) set.add(b.value); else set.delete(b.value);
      apply();
    });
  });
  function applyPrice() {
    state.pmin = pmin && pmin.value !== '' ? Math.max(0, parseInt(pmin.value, 10) || 0) : null;
    state.pmax = pmax && pmax.value !== '' ? Math.max(0, parseInt(pmax.value, 10) || 0) : null;
    apply();
  }
  var priceOk = root.querySelector('[data-alv-price-apply]');
  if (priceOk) priceOk.addEventListener('click', applyPrice);
  [pmin, pmax].forEach(function (i) { if (i) i.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyPrice(); } }); });

  function clearAll() {
    state = { cat: 'all', diameter: new Set(), application: new Set(), installation: new Set(), pmin: null, pmax: null };
    catBtns.forEach(function (b) { var on = b.dataset.cat === 'all'; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on); });
    facetBoxes.forEach(function (b) { b.checked = false; });
    if (pmin) pmin.value = ''; if (pmax) pmax.value = '';
    apply();
  }
  root.querySelectorAll('[data-alv-clear]').forEach(function (b) { b.addEventListener('click', clearAll); });

  /* ---- drawer mobile ---- */
  function openFilters() { root.classList.add('is-filters-open'); var s = root.querySelector('[data-alv-scrim]'); if (s) s.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeFilters() { root.classList.remove('is-filters-open'); var s = root.querySelector('[data-alv-scrim]'); if (s) s.hidden = true; document.body.style.overflow = ''; }
  root.querySelectorAll('[data-alv-open-filters]').forEach(function (b) { b.addEventListener('click', openFilters); });
  root.querySelectorAll('[data-alv-close-filters],[data-alv-apply]').forEach(function (b) { b.addEventListener('click', closeFilters); });
  var scrim = root.querySelector('[data-alv-scrim]');
  if (scrim) scrim.addEventListener('click', closeFilters);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });

  /* ---- ordenação nativa (recarrega) ---- */
  function bindSort(id) {
    var s = document.getElementById(id);
    if (!s) return;
    s.addEventListener('change', function () {
      var p = new URLSearchParams(window.location.search);
      p.set('sort_by', s.value);
      window.location.search = p.toString();
    });
  }
  bindSort('alv-sort'); bindSort('alv-sort-m');

  readURL();
  apply();
})();
